import CloseIcon from '@mui/icons-material/Close';
import { useEffect } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { API_URL } from '../../const/api';
import { CloseButton, ImgContainer, ModalContainer } from './WelcomeModalElements';
import { useSelector } from 'react-redux';
import { selectDetectedCountry } from '../../features/user/userSlice';


const WelcomeModal = ({handleClose, open}) => {
  const [t, i18n] = useTranslation('global');
  const [bgVideo, setBgVideo] = useState('');
  const [bgDesk, setBgDesk] = useState('');
  const [bgMob, setBgMob] = useState('');

  const [bgDeskByCountry, setBgDeskByCountry] = useState(null);
  const [bgMobByCountry, setBgMobByCountry] = useState(null);
	const detectedCountry = useSelector(selectDetectedCountry);

  useEffect(()=>{
    const loadData = async () => {
      let mostrarImagen = false;
      let home_url = '';
      let video = await axios.post(API_URL+'videoBienvenida', {});
      if(video.data.response!=='vacio') {
        home_url = video.data.response.home_url;
        if(home_url?.includes('youtube')) {
          home_url = home_url.replace("watch?v=", "embed/");
          setBgVideo(home_url);
        } else mostrarImagen=true;
      } else mostrarImagen = true;

      if(mostrarImagen) {
        let lang = i18n.language;
        if(detectedCountry==='VE'||detectedCountry==='PE'||detectedCountry==='AR'){
          let rutaDesk = `es-desk-welcome-${detectedCountry.toLowerCase()}`;
          let rutaMob = `es-mob-welcome-${detectedCountry.toLowerCase()}`;
          axios.all([
            axios.post(API_URL+'imagenes', {ruta: rutaDesk}),
            axios.post(API_URL+'imagenes', {ruta: rutaMob})
          ])
          .then(axios.spread((desk, mob) => {
            let jdesk = JSON.parse(desk.data);
            let jmob = JSON.parse(mob.data);
            setBgDeskByCountry(jdesk);
            setBgMobByCountry(jmob);
          }))
        }

        axios.all([
          axios.post(API_URL+'imagenes', {ruta: `${lang}-desk-welcome`}),
          axios.post(API_URL+'imagenes', {ruta: `${lang}-mob-welcome`})
        ])
        .then(axios.spread((desk, mob) => {
          let jdesk = JSON.parse(desk.data);
          let jmob = JSON.parse(mob.data);

          setBgDesk(jdesk);
          setBgMob(jmob);
        }))
      }
    }

    loadData();
  },[])

  return (
    <>
    {(bgDesk && bgMob && open) &&
    <ModalContainer className={open ? 'open' : 'close'}>
      <ImgContainer desk={(bgDeskByCountry && bgDeskByCountry.length) ? bgDeskByCountry : bgDesk} mob={(bgMobByCountry && bgMobByCountry.length) ? bgMobByCountry : bgMob}>
        <CloseButton onClick={handleClose}>
          <CloseIcon/>
        </CloseButton>
      </ImgContainer>
    </ModalContainer>}

    {(bgVideo&&open) && <ModalContainer className={open ? 'open' : 'close'}>
        <ImgContainer desk={null} mob={null}>
          <CloseButton onClick={handleClose}>
            <CloseIcon/>
          </CloseButton>
					<iframe title='Video Bienvenida' src={`${bgVideo}?autoplay=1&rel=0&showinfo=0&controls=0&modestbranding=0`} className="youtube-player" type="text/html" width="100%" height="100%" frameBorder="0" allowfullscreen></iframe>
        </ImgContainer>
      </ModalContainer>}
    </>
  )
}

export default WelcomeModal